import { render, staticRenderFns } from "./RememberAccount.vue?vue&type=template&id=0fc731ef&scoped=true&"
import script from "./RememberAccount.vue?vue&type=script&lang=js&"
export * from "./RememberAccount.vue?vue&type=script&lang=js&"
import style0 from "./RememberAccount.vue?vue&type=style&index=0&id=0fc731ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc731ef",
  null
  
)

export default component.exports